// Update reports page design and functionality
import React from 'react';
import { useRef, useState } from 'react';
import styles from '../css/updatedReports.module.css';
import reportsDef from '../jsonFIles/reportsDef.json';
import SparkLine from '../components/SparkLine';
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function UpdatedReports() {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const reportNumber = useRef(0);

  function validate() {
    if (!fromDate) {
      alert('Must enter from date');
      fromDateRef.current.focus();
      return false;
    }

    if (!toDate) {
      alert('Must enter to date');
      toDateRef.current.focus();
      return false;
    }

    if (toDate < fromDate) {
      alert('Start date cannot be after end date');
      fromDateRef.current.focus();
      return false;
    }

    return true;
  }

  function renderReportContent() {
    return (
      <div className={styles.reportsGrid}>
        {reportsDef.map((r, i) => (
          <div
            className={styles.reportCard}
            key={i}
            onClick={() => {
              if (!validate()) {
                return;
              }
              reportNumber.current = r.func;
              navigate(r.goto, {
                state: { rptNumber: r.func, startDate: fromDate, endDate: toDate, rptName: r.name },
              });
            }}
          >
            <div className={styles.cardTop}>
              <div className={styles.reportIcon} />
              {/* <TiChartLine size={'18px'} color="#fff" /> */}
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <polyline
                  points="1,10 4,6 7,8 10,3 15,7"
                  stroke="#5B7FFF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className={`${styles.cardBadge} ${styles['badge_' + r.color.toLowerCase()]}`}>{r.badge}</span>
            </div>
            <div>
              <div className={styles.cardName}>{r.name}</div>
              <div className={styles.cardDesc}>{r.desc}</div>
            </div>
            <SparkLine data={r.sparkData} color={r.sparkColor} />
            <div className={styles.cardFooter}>
              <span className={styles.cardUpdated}>Updated {r.updated}</span>
              <svg className={styles.cardArrow} viewBox="0 0 16 16" width="16" height="16" fill="none">
                <path
                  d="M3 8h10M9 4l4 4-4 4"
                  stroke="currentColor"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.portal}>
      <div className={styles.topbar}>
        <div className={styles.topbarLeft}>
          <div className={styles.logoMark}>
            <svg>
              <rect x="1" y="1" width="5" height="5" fill="#fff" rx="1.5" opacity="0.9" />
              <rect x="8" y="1" width="5" height="5" fill="#fff" rx="1.5" opacity="0.6" />
              <rect x="1" y="8" width="5" height="5" fill="#fff" rx="1.5" opacity="0.6" />
              <rect x="8" y="8" width="5" height="5" fill="#fff" rx="1.5" opacity="0.6" />
            </svg>
          </div>
          <div>
            <div className={styles.portalTitle}>Reports Portal</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ color: 'white' }}> - Select a date range and then click one of the cards below</div>
          </div>
        </div>
        <div className={styles.topbarRight}>
          <a className={styles.exportBtn} href="##" onClick={() => navigate('/')}>
            <FaHome size={20} color="white" style={{ paddingTop: '5px' }} />
            <span> Home</span>
          </a>
          <fieldset>
            <legend> From Date</legend>
            <input
              ref={fromDateRef}
              type="date"
              required
              id="from"
              name="from"
              className={styles.dateInput}
              value={fromDate || ''}
              onChange={(e) => {
                setFromDate(e.target.value);
                console.log(fromDate, 'From Date');
              }}
              onBlur={(e) => {
                setFromDate(e.target.value);
                console.log(fromDate, 'From Date on focus');
              }}
            />
          </fieldset>
          <fieldset>
            <legend> To Date</legend>
            <input
              ref={toDateRef}
              type="date"
              required
              id="to"
              name="to"
              className={styles.dateInput}
              value={toDate || ''}
              onChange={(e) => {
                setToDate(e.target.value);
              }}
              onBlur={(e) => {
                setToDate(e.target.value);
              }}
            />
          </fieldset>
          <div className={styles.dateRange}>
            <div className={styles.dateDot}></div>
            {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M2 3L5 6L8 3" stroke="#8BBFA8" strokeLinecap="round" />
            </svg>
          </div>
        </div>
      </div>
      <div className={styles.main}>
        <div className={styles.sidebar}>
          <div className={styles.sidebarSection}>Navigation</div>
          <div className={styles.sidebarItem + ' ' + styles.active}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <rect x="1" y="1" width="5" height="5" fill="#fff" rx="1.5" opacity="0.9" />
              <rect x="8" y="1" width="5" height="5" fill="#fff" rx="1.5" opacity="0.6" />
              <rect x="1" y="8" width="5" height="5" fill="#fff" rx="1.5" opacity="0.6" />
              <rect x="8" y="8" width="5" height="5" fill="#fff" rx="1.5" opacity="0.6" />
            </svg>
            All Reports
          </div>
          {/* <div>
            <div className={styles.sidebarSection}>Activity</div>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <polyline
                points="1,10 4,6 7,8 10,3 15,7"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div> */}
          <div>
            {reportsDef.map((grp, id) =>
              grp.reportGrp.toLowerCase() === 'activity' ? (
                <div key={id}>
                  <div className={styles.sidebarSection}>{grp.reportGrp.toUpperCase()}</div>
                  {reportsDef.map((item, i) =>
                    item.func === 1 ? (
                      <div
                        className={styles.sidebarItem}
                        key={i}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }
                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <polyline
                            points="1,10 4,6 7,8 10,3 15,7"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {item.name}
                      </div>
                    ) : item.func === 2 ? (
                      <div
                        className={styles.sidebarItem}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }
                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4" />
                          <polyline
                            points="8,4 8,8 11,10"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                          />
                        </svg>
                        {item.name}
                      </div>
                    ) : item.func === 3 ? (
                      <div
                        className={styles.sidebarItem}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }

                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <path
                            d="M8 2v2M8 12v2M2 8h2M12 8h2"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                          />
                          <circle cx="8" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.4" />
                        </svg>
                        {item.name}
                      </div>
                    ) : item.func === 4 ? (
                      <div
                        className={styles.sidebarItem}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }
                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <path
                            d="M8 2v2M8 12v2M2 8h2M12 8h2"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                          />
                          <circle cx="8" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.4" />
                        </svg>
                        Wait Time
                      </div>
                    ) : null,
                  )}
                </div>
              ) : grp.reportGrp.toLowerCase() === 'tickets' ? (
                <div key={id}>
                  <div className={styles.sidebarSection}>{grp.reportGrp.toUpperCase()}</div>
                  {reportsDef.map((item, i) =>
                    item.func === 5 ? (
                      <div
                        className={styles.sidebarItem}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }
                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <rect
                            x="2"
                            y="3"
                            width="12"
                            height="10"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="1.4"
                          />
                          <line
                            x1="5"
                            y1="7"
                            x2="11"
                            y2="7"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                          />
                          <line
                            x1="5"
                            y1="10"
                            x2="9"
                            y2="10"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                          />
                        </svg>
                        {item.name}
                      </div>
                    ) : item.func === 6 ? (
                      <div
                        className={styles.sidebarItem}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }
                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <rect
                            x="2"
                            y="3"
                            width="12"
                            height="10"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="1.4"
                          />
                          <path
                            d="M5 8l2 2 4-4"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {item.name}
                      </div>
                    ) : item.func === 9 ? (
                      <div
                        className={styles.sidebarItem}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }
                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <rect
                            x="2"
                            y="3"
                            width="12"
                            height="10"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="1.4"
                          />
                          <path
                            d="M5 8l2 2 4-4"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {item.name}
                      </div>
                    ) : item.func === 10 ? (
                      <div
                        className={styles.sidebarItem}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }
                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <rect
                            x="2"
                            y="3"
                            width="12"
                            height="10"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="1.4"
                          />
                          <path
                            d="M5 8l2 2 4-4"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        Omitted Tickets
                      </div>
                    ) : null,
                  )}
                </div>
              ) : grp.reportGrp.toLowerCase() === 'traffic' ? (
                <div key={id}>
                  <div className={styles.sidebarSection}>{grp.reportGrp.toUpperCase()}</div>

                  {reportsDef.map((item, i) =>
                    item.func === 7 ? (
                      <div
                        className={styles.sidebarItem}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }
                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <path
                            d="M3 11L8 5L13 11"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {item.name}
                      </div>
                    ) : item.func === 8 ? (
                      <div
                        className={styles.sidebarItem}
                        onClick={() => {
                          if (!validate()) {
                            return;
                          }
                          navigate(item.goto, {
                            state: {
                              rptNumber: item.func,
                              startDate: fromDate,
                              endDate: toDate,
                              rptName: item.name,
                            },
                          });
                        }}
                      >
                        <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
                          <path
                            d="M3 5L8 11L13 5"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {item.name}
                      </div>
                    ) : null,
                  )}
                </div>
              ) : null,
            )}
          </div>
          {/* <div className={styles.sidebarSection}>Activity</div> */}
          {/* <div className={styles.sidebarItem}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <polyline
                points="1,10 4,6 7,8 10,3 15,7"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Activity Report
          </div> */}
          {/* <div className={styles.sidebarItem}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4" />
              <polyline points="8,4 8,8 11,10" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
            </svg>
            Stay Duration
          </div> */}
          {/* <div className={styles.sidebarItem}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <path d="M8 2v2M8 12v2M2 8h2M12 8h2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
              <circle cx="8" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.4" />
            </svg>
            Wait Time
          </div> */}
          {/* <div className={styles.sidebarSection}>Tickets</div>
          <div className={styles.sidebarItem}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <rect x="2" y="3" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.4" />
              <line x1="5" y1="7" x2="11" y2="7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
              <line x1="5" y1="10" x2="9" y2="10" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
            </svg>
            Open Tickets
          </div> */}
          {/* <div className={styles.sidebarItem}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <rect x="2" y="3" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.4" />
              <path
                d="M5 8l2 2 4-4"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Closed Tickets
          </div> */}
          {/* <div className={styles.sidebarItem}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <rect x="2" y="3" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.4" />
              <path
                d="M5 8l2 2 4-4"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Manual Tickets
          </div> */}
          {/* <div className={styles.sidebarItem}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <rect x="2" y="3" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.4" />
              <path
                d="M5 8l2 2 4-4"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Omitted Tickets
          </div> */}
          {/* <div className={styles.sidebarSection}>Traffic</div> */}
          {/* <div className={styles.sidebarItem}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <path
                d="M3 11L8 5L13 11"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            In Traffic
          </div> */}
          {/* <div className={styles.sidebarItem}>
            <svg className={styles.icon} viewBox="0 0 16 16" fill="none">
              <path
                d="M3 5L8 11L13 5"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Out Traffic
          </div> */}
        </div>
        <div className={styles.content}>{renderReportContent()}</div>
      </div>
    </div>
  );
}

export default UpdatedReports;
